import { Button } from '@/components/form/baseInputs/Button';

export interface DocumentProcessingCompletionButtonProps {
  /**
   * Label for the completion button
   */
  completionButtonLabel: string;
  /**
   * Callback when the completion button is clicked
   */
  onCompletionClick: () => void;
  /**
   * Whether the button should be disabled
   */
  disabled?: boolean;
  /**
   * Whether the button is in a loading state
   */
  loading?: boolean;
}

export function DocumentProcessingCompletionButton({
  completionButtonLabel,
  onCompletionClick,
  disabled = false,
  loading = false,
}: DocumentProcessingCompletionButtonProps) {
  return (
    <Button
      variant="primary"
      size="sm"
      fullWidth
      onClick={onCompletionClick}
      disabled={disabled}
      loading={loading}
    >
      {completionButtonLabel}
    </Button>
  );
}
